/**
 * Inputs: preview copy for removing a plan or booking. Outputs: a two-step
 * owner confirmation. The confirm button is not the form's primary submit.
 */

import { useState } from "react";
import type { RemovalPreview } from "@shared/plan-lifecycle.ts";

export function RemoveRecord({
  preview,
  busy,
  error,
  onConfirm,
}: {
  preview: RemovalPreview;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <section className="danger-zone">
      {open ? (
        <>
          <h2 className="serif">{preview.title}</h2>
          <p>{preview.body}</p>
          {preview.blocked ? <p className="banner warn">{preview.blocked}</p> : null}
          {error ? <p className="banner crit">{error}</p> : null}
          <div className="row-actions">
            {preview.blocked ? null : (
              <button
                className="btn-danger"
                type="button"
                disabled={busy}
                onClick={onConfirm}
              >
                {busy ? "Removing…" : preview.confirmLabel}
              </button>
            )}
            <button className="btn-ghost" type="button" onClick={() => setOpen(false)}>
              Keep it
            </button>
          </div>
        </>
      ) : (
        <button className="btn-ghost" type="button" onClick={() => setOpen(true)}>
          Remove from the trip
        </button>
      )}
    </section>
  );
}
